import SlideShow from './presenter';
export default SlideShow;
